// Datos del consultorio — Dr. Pablo Salgado · Gastroenterología
export const SITE = {
  doctor: "Dr. Pablo Salgado",
  fullName: "Dr. Pablo Salgado Rosado",
  specialty: "Gastroenterología y Endoscopía Digestiva",
  phone: "099 311 8688",
  phoneIntl: "593993118688",
  emergency: "099 876 0812",
  email: "citas@drpablosalgado.com",
  hospital: "Hospital de Especialidades de la Ciudad",
  address: "Torre Sur, Piso 4, Consultorio 402",
  hours: [
    { d: "Consulta", h: "Previa cita" },
    { d: "Emergencias", h: "24/7" },
  ],
};

export const WHATSAPP_URL = `https://wa.me/${SITE.phoneIntl}?text=${encodeURIComponent("Hola Dr. Salgado, quisiera agendar una cita.")}`;

export const IMG = {
  logo: "/img/logo.webp",
  logoWhite: "/img/logo-white.webp",
  doctor: "/img/doctor.webp",
  endo1: "/img/endoscopia-1.webp",
  endo2: "/img/endoscopia-2.webp",
  anatomia: "/img/anatomia.webp",
  obesidad: "/img/obesidad.webp",
  retrato: "/img/doctor-retrato.webp",
};

export const TOPICS = [
  {
    img: "/img/tema-ulceras.webp", title: "Úlceras gástricas", pos: "object-top",
    text: "La endoscopía permite ver directamente el estómago, detectar úlceras antes de que sangren o se perforen e identificar su causa (H. pylori, antiinflamatorios u otros irritantes) para dar un tratamiento oportuno.",
    alt: "Endoscopía: la mejor forma de detectar úlceras gástricas",
  },
  {
    img: "/img/tema-controles.webp", title: "Controles a tiempo",
    text: "No esperes a que una enfermedad se complique. Muchas condiciones digestivas no dan síntomas al inicio: los controles periódicos y la endoscopía o colonoscopía en el momento indicado permiten tratarlas a tiempo.",
    alt: "No esperes que una enfermedad se complique. Realízate tus controles a tiempo",
  },
  {
    img: "/img/tema-deposicion.webp", title: "Cambios en la deposición",
    text: "Diarrea, estreñimiento, heces más delgadas, con sangre o negras que duran más de 2–3 semanas merecen una valoración. Pueden deberse desde a intestino irritable hasta a pólipos o cáncer de colon, que se detectan a tiempo con colonoscopía.",
    alt: "¿Has notado cambios en tu deposición? Contáctame",
  },
  {
    img: "/img/tema-lacteos.webp", title: "Problemas para digerir los lácteos",
    text: "Hinchazón, gases, dolor o diarrea después de consumir lácteos suelen deberse a intolerancia a la lactosa (déficit de lactasa). Se confirma con pruebas sencillas y se controla con ajustes en la alimentación.",
    alt: "¿Tienes problemas para digerir los lácteos?",
  },
  {
    img: "/img/tema-stent-biliar.webp", title: "Stent biliar en tumores biliopancreáticos",
    text: "Cuando un tumor obstruye la vía biliar aparecen piel amarilla (ictericia), picazón y orina oscura. Mediante CPRE colocamos un stent que restablece el drenaje de la bilis sin cirugía abierta y mejora la calidad de vida.",
    alt: "Colocación de stent biliar en tumores biliopancreáticos",
  },
  {
    img: "/img/tema-sangrado.webp", title: "Sangrado de divertículos y tumores",
    text: "El sangrado digestivo se puede controlar por vía endoscópica con clips, inyección o coagulación. Si notas sangre en las heces o heces negras, busca atención de inmediato: atendemos emergencias 24/7.",
    alt: "Control de sangrado de divertículos y tumores",
  },
];

export const FEATURED = [
  {
    id: "endoscopia", title: "Endoscopía digestiva", img: "endo1",
    text: "Estudio del esófago, estómago y duodeno para detectar y tratar úlceras, gastritis, reflujo, sangrado y otras patologías. Diagnóstica y terapéutica, con sedación para tu comodidad.",
  },
  {
    id: "cpre", title: "CPRE", img: "endo2",
    text: "Colangiopancreatografía retrógrada endoscópica: estudia y trata la vía biliar y el páncreas. Permite extraer cálculos del colédoco y colocar prótesis (stents) sin cirugía abierta.",
  },
  {
    id: "obesidad", title: "Sobrepeso y obesidad", img: "obesidad",
    text: "Tratamientos no quirúrgicos para perder peso y cambiar hábitos: balón gástrico y medicamentos como semaglutida (Ozempic) o liraglutida (Saxenda), siempre con indicación y control médico.",
  },
];

export const SERVICES = [
  { icon: "ScanEye", title: "Endoscopía digestiva alta", text: "Visualiza esófago, estómago y duodeno para detectar y tratar enfermedades." },
  { icon: "Microscope", title: "Colonoscopía", text: "Examina colon y recto para detectar, diagnosticar y tratar enfermedades; clave en la prevención del cáncer colorrectal." },
  { icon: "Scissors", title: "Polipectomía", text: "Extracción de pólipos del colon para prevenir el cáncer colorrectal y analizar el tejido." },
  { icon: "Expand", title: "Dilataciones y stents", text: "Restaura el paso del tubo digestivo en estrechamientos (estenosis) mediante dilatación o prótesis." },
  { icon: "Droplet", title: "Hígado graso y hepatitis", text: "Diagnóstico y control de la grasa en el hígado y de las hepatitis, para evitar inflamación y daño." },
  { icon: "Activity", title: "Cirrosis hepática", text: "Seguimiento integral de la enfermedad hepática crónica y de sus complicaciones." },
  { icon: "Stethoscope", title: "Enfermedades digestivas", text: "Gastritis, colitis, intestino irritable, hemorroides, enfermedad inflamatoria intestinal y pancreatitis." },
  { icon: "ShieldPlus", title: "Hemorragia digestiva", text: "Técnicas endoscópicas para detener sangrados del tubo digestivo, también en emergencias." },
  { icon: "Target", title: "Resección de lesiones", text: "Extirpación endoscópica de lesiones y tumores tempranos del aparato digestivo." },
];

export const WARNING_SIGNS = [
  "Acidez o reflujo frecuente",
  "Dolor o distensión abdominal persistente",
  "Sangre en las heces o heces negras",
  "Cambios en el ritmo intestinal (diarrea o estreñimiento)",
  "Dificultad o dolor al tragar",
  "Pérdida de peso sin explicación",
  "Antecedentes familiares de cáncer digestivo",
];

export const CPRE_GALLERY = [
  { img: "/img/endoscopia-avanzada.webp", alt: "Endoscopía avanzada: CPRE con extracción de cálculos y control radiológico", tall: false },
  { img: "/img/cpre-calculos-1.webp", alt: "CPRE: extracción de múltiples cálculos biliares", tall: true },
  { img: "/img/cpre-calculos-2.webp", alt: "CPRE: retiro de cálculos biliares", tall: true },
];

export const TESTIMONIALS = [
  { name: "Nelson Castillo", text: "El Dr. Salgado explica todo con claridad y paciencia. Mi endoscopia fue rápida y sin molestias. Recomiendo totalmente su consulta." },
  { name: "Jacinta Romero", text: "Llevaba años yendo mucho al baño. El Dr. Pablo me hizo una endoscopia y detectó que tenía úlceras. Gran profesional y muy humano." },
  { name: "Marcos Gándara", text: "Atención de primera. Se nota que se actualiza constantemente y se preocupa por el resultado del paciente. Recomendado." },
];
